import React from "react";
import CourseTopicMaterials from "../../../../hooks/CourseTopicMaterials";
import { secondFormCourseTopicMaterials } from "../../../../shared/components/FormCourseMaterials/FormCourseMaterials";
import { secondFormTextBooks } from "../../../../shared/components/FormCourseMaterials/FormImages";
import TextBookImages from "../../../../shared/components/TextBookImages/TextBookImages";

import pic3 from '../../../../assets/Images/PageDetails/SecondForm/Picture3.webp';
import pic4 from '../../../../assets/Images/PageDetails/SecondForm/Picture4.webp';


const SecondFormContent = () => {
  return (
    <>
      <CourseTopicMaterials items={secondFormCourseTopicMaterials} leftImage={pic3} rightImage={pic4} />
      <TextBookImages images={secondFormTextBooks} form='Second' />
    </>
  );
}

export default SecondFormContent;
